import { render, staticRenderFns } from "./TimeEntriesNavigationItem.vue?vue&type=template&id=07a970c8&"
import script from "./TimeEntriesNavigationItem.vue?vue&type=script&lang=js&"
export * from "./TimeEntriesNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TimeEntriesNavigationItem.vue"
export default component.exports